module.exports = __webpack_public_path__ + "img/people.f4937898.svg";